// Constants used only by the Who's Who feature. Anything shared with another
// feature (THEME_COLOR, PILL_RADIUS_FILL, PHONE_TOOL_USER_BASE) stays in the
// top-level constants.js.

// Badge-photo URL prefix; append `${alias}.jpg`.
export const PROFILE_PHOTO_BASE = "/photos/";

// Square avatar edge, in px. Half of this is used as the fill radius for a full circle.
export const AVATAR_SIZE = 48;

// Display fallback for unavailable V2 card fields.
export const MISSING_VALUE = "—";

// V2 participant filter contract.
export const EXTERNAL_PARTICIPANTS_VALUE = -1;
export const EXTERNAL_PARTICIPANTS_LABEL = "External participants";

// V2 relationship-frequency display threshold. Backend relevance ranking remains 50.
export const REGULAR_COLLABORATOR_MIN_MEETINGS = 11;

export const INSIGHT_KIND = {
  NEW_AMAZONIAN: "new-amazonian",
  RECENTLY_PROMOTED: "recently-promoted",
  NEW_ROLE: "new-role",
  NEW_TEAM: "new-team",
  ANNIVERSARY: "anniversary",
  NETWORK_CONNECTION: "network-connection",
  MUTUAL_COLLEAGUES: "mutual-colleagues",
  SHARED_REPORTING: "shared-reporting",
};

export const PINNED_INSIGHT_KINDS = [
  INSIGHT_KIND.NEW_AMAZONIAN,
  INSIGHT_KIND.RECENTLY_PROMOTED,
  INSIGHT_KIND.NEW_ROLE,
  INSIGHT_KIND.NEW_TEAM,
  INSIGHT_KIND.ANNIVERSARY,
];

export const WHOS_WHO_SECTION_ID = {
  FIRST_TIME_MEETING: "first-time-meeting",
  MET_BEFORE: "met-before",
  REGULAR_COLLABORATORS: "regular-collaborators",
  EXTERNAL_PARTICIPANTS: "external-participants",
  YOU: "you",
};

// The order here is the V2 display order. Section rendering must consume this configuration rather
// than repeating the order or labels elsewhere.
export const WHOS_WHO_SECTION_CONFIG = [
  { id: WHOS_WHO_SECTION_ID.FIRST_TIME_MEETING, label: "First time meeting" },
  { id: WHOS_WHO_SECTION_ID.MET_BEFORE, label: "Met before" },
  {
    id: WHOS_WHO_SECTION_ID.REGULAR_COLLABORATORS,
    label: "Regular collaborators",
  },
  {
    id: WHOS_WHO_SECTION_ID.EXTERNAL_PARTICIPANTS,
    label: EXTERNAL_PARTICIPANTS_LABEL,
  },
  { id: WHOS_WHO_SECTION_ID.YOU, label: "You" },
];

// Distinct org accent colours, spread evenly around the hue wheel by the golden angle so
// adjacent orgs stay visually far apart no matter how many there are.
const ORG_COLOR_START_HUE = 170;
const ORG_COLOR_GOLDEN_ANGLE = 137.508;

// Render states for the Who's Who panel, passed as the `state` prop.
export const WHOS_WHO_STATE = {
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error",
};

export const orgColor = (index) =>
  `hsl(${(ORG_COLOR_START_HUE + index * ORG_COLOR_GOLDEN_ANGLE) % 360}, 70%, 30%)`;
